import { acquireApiToken } from "../auth/auth";
import axios from "axios";

let controller = null;

export function abortFetch() {
  if (controller) {
    controller.abort();
    controller = null;
  }
}

// Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 300000, // 300 seconds
});

const defaultHeaders = {
  "Content-Type": "application/json",
  "Ocp-Apim-Subscription-Key":
    process.env.REACT_APP_API_APIM_SUBSCRIPTION_KEY || "",
  "Access-Control-Allow-Origin": "*",
};

// Merge default headers + auth token
const getHeaders = async () => {
  const token = await acquireApiToken();

  return {
    ...defaultHeaders,
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export const getData = async (url = "") => {
  try {
    const res = apiClient.get(url, { headers: await getHeaders() });
    return (await res).data;
  } catch (error) {
    console.error("Error fetching data", error);
    return null;
  }
};

export const postData = async (postData, url = "") => {
  try {
    const res = apiClient.post(url, postData, { headers: await getHeaders() });
    return (await res).data;
  } catch (error) {
    console.error("Error fetching data", error);
    return null;
  }
};

export const postDataWithAbort = async (postData, url = "") => {
  try {
    abortFetch(); // cancel previous if any
    controller = new AbortController();
    const res = apiClient.post(url, postData, {
      headers: await getHeaders(),
      signal: controller.signal,
    });
    return (await res).data;
  } catch (error) {
    console.error("Error fetching data", error);
    return null;
  }
};

export const postFetchData = async (serviceName, requestBody) => {
  const token = await acquireApiToken();
  return fetch(process.env.REACT_APP_API_BASE_URL + `${serviceName}`, {
    method: 'POST',
    headers: {
      'Ocp-Apim-Subscription-Key':
        process.env.REACT_APP_API_APIM_SUBSCRIPTION_KEY || '',
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  });
};